// src/view/linkAccount/components/EvWhereMemberLookup.tsx

import React, { useEffect, useState } from "react";
import { Flex, Line } from "../style";
import { Label, Input } from "../../../styles/commonStyle";
import { cardTitleColor2, orangeColor2 } from "../../../styles/theme";
import { AppleButton, GoogleButton, SocialKakao } from "../../../components/socialButton/socialButton";
import EvModal from "../../../components/modal/evModal";
import { useRecoilState } from "recoil";
import { evWhereMemberState, getEvWherePhoneState, isEvWhereMemberState, requiredDataState } from "../../../recoil/atoms";
import { ResponseModel, RESULT } from "../../../model/response";
import usePost from "../../../hooks/usePost";
import { evWhereMemberSelector } from "../../../recoil/variableAtom";
import { useKakaoLogin } from "../../../hooks/useKakaoLogin";
import PasswordToggleButton from "../../../components/passwordToggleButton/passwordToggleButton";
import { onInputOnlyEng } from "../../../validation";

interface EvWhereMemberLookupProps {
    isSearchCompleted: boolean;
    setIsSearchCompleted: (isSearchCompleted: boolean) => void;
}

export default function EvWhereMemberLookup({
    isSearchCompleted,
    setIsSearchCompleted
}: EvWhereMemberLookupProps) {
    const [modalOpen, setModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [requiredData, setRequiredData] = useRecoilState(requiredDataState);
    const [isEvWhereMember, setIsEvWhereMember] = useRecoilState(isEvWhereMemberState);
    const [evWhereMember, setEvWhereMember] = useRecoilState(evWhereMemberState);
    const [getEvWherePhone, setEvWherePhone] = useRecoilState(getEvWherePhoneState);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const response: ResponseModel<any> = usePost({
        recoilSelector: evWhereMemberSelector,
        data: requiredData,
        recoilState: isEvWhereMemberState,
    });

    useEffect(() => {
        if (!evWhereMember || !response) return;

        if (response?.result === RESULT.OK) {
            setEvWherePhone(response.data.phone);
            setIsSearchCompleted(true);
        } else if (response?.result === RESULT.FAIL) {
            setModalOpen(true);
            setModalMessage(response?.msg || '');
            setEvWhereMember(undefined);
            setIsSearchCompleted(false);
        }
    }, [response]);

    const handleEvWhereMemberLookup = () => {
        setEvWhereMember({
            lgn_Id: email,
            lgnPassword: password
        });
        setIsEvWhereMember(true);
    }

    useKakaoLogin();

    useEffect(() => {
        // URL에서 인증 코드 추출
        const code = new URLSearchParams(window.location.search).get('code');

        if (code && window.opener) {
            // 부모 창으로 인증 코드 전달
            window.opener.postMessage({ type: 'KAKAO_LOGIN_SUCCESS', code }, window.location.origin);
            // 팝업 창 닫기
            window.close();
        }
    }, []);

    return (
        <>
            <Flex style={{ maxWidth: "600px", marginTop: "30px" }} gap="10px">
                <Flex style={{ width: "100%" }} flexDirection="column" gap="10px">
                    <Flex changeFlexDirection="column" changeAlignItems="start" gap="10px" style={{ width: "100%" }}>
                        <Label width="170px" changeFontSize="0.875rem" style={{ fontWeight: 400 }}>evWhere 이메일 아이디</Label>
                        <div style={{ width: "100%" }}>
                            <Input
                                style={{ flex: 350, height: "40px" }}
                                name="evWhereEmail"
                                autoComplete="new-email"
                                type="text"
                                placeholder="evWhere 이메일 아이디를 입력해주세요."
                                borderRadius="0.375rem"
                                onChange={(e) => {
                                    setEmail(e.target.value);
                                }}
                                onInput={onInputOnlyEng}
                            />
                        </div>
                    </Flex>
                    <Flex changeFlexDirection="column" changeAlignItems="start" gap="10px" style={{ width: "100%" }}>
                        <Label width="170px" changeFontSize="0.875rem" style={{ fontWeight: 400 }}>evWhere 비밀번호</Label>
                        <div style={{ position: "relative", width: "100%" }}>
                            <Input
                                style={{ flex: 350, height: "40px" }}
                                name="evWherePassword"
                                autoComplete="new-password"
                                type={showPassword ? "text" : "password"}
                                placeholder="evWhere 비밀번호를 입력해주세요."
                                borderRadius="0.375rem"
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                }}
                                onInput={onInputOnlyEng}
                            />
                            <PasswordToggleButton
                                showPassword={showPassword}
                                onClick={() => setShowPassword(!showPassword)}
                            />
                        </div>
                    </Flex>
                </Flex>
                <button
                    style={{
                        backgroundColor: orangeColor2,
                        color: "white",
                        borderRadius: "5px",
                        width: "120px",
                        alignSelf: "stretch",
                    }}
                    onClick={() => {
                        handleEvWhereMemberLookup();
                    }}
                >
                    회원 조회
                </button>
            </Flex>
            <Line />
            <Flex style={{ maxWidth: "600px", marginTop: "30px" }} gap="10px">
                <div style={{ flex: 140 }}>소셜 로그인</div>
                <Flex style={{ flex: 350 }} gap="20px">
                    <SocialKakao />
                    <GoogleButton />
                    <AppleButton />
                </Flex>
            </Flex>
            <EvModal
                open={modalOpen}
                message={modalMessage}
                onClose={() => {
                    setModalOpen(false);
                }}
            />
        </>
    );
}